import React from 'react';
import { Text, Theme, TextButton } from '@amzn/storm-ui-v3';
import styled from 'styled-components';
import { useTranslation, Trans } from 'react-i18next';
import { StyledCard } from '@urc-ui/components/styles';

const PrimaryErrorText = styled(Text)`
  text-align: center;
  font-weight: bold;
`;

const SecondaryErrorText = styled(Text)`
  text-align: center;
  font-weight: normal;
`;

const StyledErrorCard = styled(StyledCard)`
  margin-top: ${({ theme }) => theme.spacing.xxlarge};
  padding-top: ${({ theme }: { theme: Theme }) => theme.spacing.xxlarge};
  padding-bottom: ${({ theme }: { theme: Theme }) => theme.spacing.xxlarge};
  ${PrimaryErrorText} + ${SecondaryErrorText} {
    margin-top: ${({ theme }: { theme: Theme }) => theme.spacing.small};
  }
`;

const StyledTextButton = styled(TextButton)`
  vertical-align: baseline;
`;

const Refresh = ({ children }: { children?: React.ReactNode }) => {
  return <StyledTextButton onClick={() => window.location.reload()}>{children}</StyledTextButton>;
};

const ErrorCard = () => {
  const { t: translate } = useTranslation();
  return (
    <StyledErrorCard padding={'none'}>
      <PrimaryErrorText styleAs={'h1'} fontSize={'large'}>
        {translate('sspa_rcm_ad_reports_generic_error', 'Sorry, something went wrong')}
      </PrimaryErrorText>
      <SecondaryErrorText fontSize={'base'}>
        <Trans
          t={translate}
          i18nKey={'sspa_rcm_ad_reports_please_refresh'}
          defaults={'<TButton>Refresh page</TButton> to try again'}
          components={{
            TButton: <Refresh />
          }}
        />
      </SecondaryErrorText>
    </StyledErrorCard>
  );
};

export { ErrorCard };
